import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { FETCH_DMA_OVERRIDES, FETCH_PLAYER_CONFIG } from './DebugActions';

const INITIAL_STATE = {
  dmaOverrides: null,
  playerConfig: null,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  switch (action.type) {
    case FETCH_DMA_OVERRIDES: {
      const dmaOverrides = _.get(action, 'payload.data', null);
      return {
        ...state,
        dmaOverrides,
        errors,
      };
    }
    case FETCH_PLAYER_CONFIG: {
      const playerConfig = _.get(action, 'payload.data', null);
      return {
        ...state,
        playerConfig,
        errors,
      };
    }
    default:
      return state;
  }
}
